var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCloseSquareBlack = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close Square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Close Square_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3915 0.666016H12.6165C15.4415 0.666016 17.3332 2.64935 17.3332 5.59935V12.4085C17.3332 15.3502 15.4415 17.3327 12.6165 17.3327H5.3915C2.5665 17.3327 0.666504 15.3502 0.666504 12.4085V5.59935C0.666504 2.64935 2.5665 0.666016 5.3915 0.666016ZM11.5082 11.4993C11.7915 11.2168 11.7915 10.7585 11.5082 10.4752L10.0248 8.99185L11.5082 7.50768C11.7915 7.22518 11.7915 6.75852 11.5082 6.47518C11.2248 6.19102 10.7665 6.19102 10.4748 6.47518L8.99984 7.95768L7.5165 6.47518C7.22484 6.19102 6.7665 6.19102 6.48317 6.47518C6.19984 6.75852 6.19984 7.22518 6.48317 7.50768L7.9665 8.99185L6.48317 10.4668C6.19984 10.7585 6.19984 11.2168 6.48317 11.4993C6.62484 11.641 6.8165 11.7168 6.99984 11.7168C7.1915 11.7168 7.37484 11.641 7.5165 11.4993L8.99984 10.0252L10.4832 11.4993C10.6248 11.6502 10.8082 11.7168 10.9915 11.7168C11.1832 11.7168 11.3665 11.641 11.5082 11.4993Z",
    fill: "#0F0F0F"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloseSquareBlack, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CloseSquareBlack.6f7be18b.svg";
export { ForwardRef as ReactComponent };